module.exports = __webpack_public_path__ + "static/img/oouyan_qr.32d08c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/oouyan_qr.png
// module id = jFi2
// module chunks = 1